export default "__VITE_ASSET__c62e1a6d__"